import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { ClickoutUrl } from '@/helpers/clickout-helper';
import { useUserStore } from '@/helpers/composables/useStores';
import { SnowplowClickoutContextGraphql, SnowplowContext, SnowplowPackageContext } from '@/helpers/tracking/providers';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';
import type { TitleDetail } from '@/interfaces/title-details-graphql';
import type { TitleOfferFragment } from '@/components/buybox/graphql/fragments/Offer.fragment';
import { OfferPresentationType } from '@/interfaces/titles';

type BuyboxRowOffer = TitleOfferFragment & {
	iconUrl?: string;
	icons?: string[];
	bundleId?: number;
	bundleTechnicalName?: string;
};

interface BuyBoxBundleProps {
	title: TitleDetail;
	offer: BuyboxRowOffer;
	additionalContexts?: SnowplowContext[];
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BuyBoxBundle',
  props: {
    title: null,
    offer: null,
    additionalContexts: { default: () => [] }
  },
  setup(__props: any) {

const props = __props as { title: TitleDetail, offer: BuyboxRowOffer, additionalContexts: SnowplowContext[] }



const toImageUrl = (path?: string, format: 'webp' | 'jpg' = 'jpg') => {
	if (path?.startsWith('/icon')) {
		return JW_CONFIG.IMAGESCALER_URL + path?.replace('{format}', format);
	}

	return path;
};

const { buyboxPresentationType } = useUserStore();
const property = computed(() => {
	if (buyboxPresentationType.value === null) return OfferPresentationType._4K; //NOTE: for tracking purposes
	return buyboxPresentationType.value;
});
const bundleLabelSuffix = computed(() => {
	switch (buyboxPresentationType.value) {
		case null:
		case OfferPresentationType._4K:
			return '4k';
		case OfferPresentationType.HD:
			return 'HD';
		default:
			return '';
	}
});

const bundleOfferUrl = computed(() => new ClickoutUrl(props.offer).toString());

function clickOut() {
	let contexts: SnowplowContext[] = [];
	const clickoutContext = SnowplowClickoutContextGraphql.fromProviderOffer(props.offer);
	const packageContext = new SnowplowPackageContext(
		props.offer.bundleId ?? props.offer.package.packageId,
		props.offer.bundleTechnicalName ?? props.offer.package.technicalName,
		'bundle'
	);
	contexts = [...props.additionalContexts, clickoutContext, packageContext];
	TrackingHelper.trackEvent(
		'clickout',
		{
			action: 'flatrate',
			label: props.offer.package.clearName,
			property: property.value,
			value: 3,
		},
		contexts
	);
}

return { __sfc: true,props, toImageUrl, buyboxPresentationType, property, bundleLabelSuffix, bundleOfferUrl, clickOut }
}

})